/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgOffroader48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M42.499 35v2.737H24.184l-18.185.012V35h36.5zm-30.5-13h-6.21c.235 1.381 0 3 0 3H12v-3zm27.5-17h-30.5v6c15.372-4 30.5-5 30.5-5s-.23-.99 0-1zM42.502 22h-6.209c.235 1.383 0 3 0 3h6.21v-3z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M12.503 21.5H5.531V35'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M35.614 35V21.671A4.673 4.673 0 0030.926 17h-13.74c-.048 0-.096 0-.145.002 0 0 0 0 0 0a4.673 4.673 0 00-4.543 4.67V35M19.5 23h9.116M13.002 29h22.616M21.498 17v18M16.998 25v10'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M42.591 35H5.531v2.75h37.06V35z'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M4.5 8l.027-.006a3.58 3.58 0 013.771 1.669L8.5 10'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M4.5 8l.027-.006a3.58 3.58 0 013.771 1.669L8.5 10'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M10.503 38.25L5.531 38v6.052a1.448 1.448 0 001.448 1.447h2.077c.8 0 1.447-.648 1.447-1.447v-5.803z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M8.502 21.25V4.5H24.06'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M17.002 25a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM2.737 10.613c.974 0 1.764-.783 1.764-1.75 0-.966-.79-1.75-1.764-1.75-.975 0-1.764.784-1.764 1.75 0 .967.79 1.75 1.764 1.75z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24 4.5v10.105M39.618 14.606H8.502M35.619 21.5h6.972V35M26.619 17v18M31.119 25v10'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M43.615 8l-.027-.006a3.58 3.58 0 00-3.77 1.669l-.203.337'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M43.615 8l-.027-.006a3.58 3.58 0 00-3.77 1.669l-.203.337'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M37.617 38.25L42.59 38v6.052a1.448 1.448 0 01-1.448 1.447h-2.076c-.8 0-1.448-.648-1.448-1.447v-5.803z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M39.617 21.25V4.5H24.059'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M31.117 25a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM45.381 10.613c.974 0 1.764-.783 1.764-1.75 0-.966-.79-1.75-1.764-1.75s-1.764.784-1.764 1.75c0 .967.79 1.75 1.764 1.75z'
      />
    </svg>
  );
}

export default SvgOffroader48;
